<template>
    <div class="inc_right">
        <!--標題區塊-->
        <div class="inctitall">
            <div class="inc_mtitle">
                {{ title }}
            </div>
        </div>
        <!--相簿區塊-->
        <div class="movieall">
            <div class="publbox" v-for="(item,index) in Img_Content">
                <div class="movpc">
                    <img :src=" '/filestore'+item.url" :title="item.name" :alt="item.name"  onerror="this.src='/images/default.jpg'">
                    </img>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
    data(){
        return{
            //文章編號
            id:"",
            //語系
            lang:"",

            //文章標題
            title:"",
            //文章內容
            content:"",
           
            //取得當前資料
            Img_Content:[
                //{url:"/images/default.jpg" , name: ""},
            ],
            //上方次類別
            sublist:{},
        };
    },
    props:["sideright_Content"],
    mounted(){
        //初始化
        this.init();
        //取得圖片資料列
        this.getImageContent() ;
    },
    watch:{
        "sideright_Content"(){
            this.init();
        },
    },
    methods:{
        init(){
            //2025-11-14 讀取FAQ下拉功能
            const script = document.createElement("script");
            script.setAttribute('nonce', 'SHhzTzNmaWIxZjZJWmVsRg==');
            script.src = "/js/faq.js";
            document.body.appendChild(script);
            this.title = this.sideright_Content.title;
            if( this.$route.query){
                //文章編號
                this.id = this.$route.query.id? this.$route.id: "";
                //語言
                this.lang = this.$route.query.lang? this.$route.query.lang: "2";
            }
        },
        //取得本次圖片列表
        async getImageContent(){
            try{
                //POST參數
                let jsonReq ={
                    TYPE:"HOME_LIST",
                    latestnews_file_SELECT:{
                        articleId: this.$route.query.id,
                        fileLang: this.lang,
                        pageIndex : 1,
                        pageSize: 999,
                    }
                };
                //Token
                let resToken = await this.userRequest.post('bicd/Token');
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/LatestNewsFile",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    this.Img_Content =[];
                    let jsonData = JSON.parse(json.Data);
                    jsonData.outData.forEach(item => {
                        let obj = {url: item.filePath , name: item.fileName };
                        this.Img_Content.push(obj);
                    });

                }
            }catch(err){
                console.log("ErrFunction: getImageContent/n " + err);
            }
        },
    }
}
</script>